import { Play } from 'lucide-react'
import { cn } from '@/utils/styles/cn'

/**
 * Shared lp-v3 video thumbnail styling — a rounded poster with an overlaid ink "▶ LABEL" pill in the
 * bottom-left. Used by BOTH the vision-section launch-film widget and the testimonial "play video"
 * thumbnail so the two look identical (only the size + poster + label differ). The poster (an <img>
 * or <video> filling `absolute inset-0`) is passed as `children`; size is set via `className`.
 */
export function LandingVideoThumbnail({
    onClick,
    label,
    ariaLabel,
    className,
    tabIndex,
    children,
}: {
    onClick: () => void
    label: string
    ariaLabel: string
    className?: string
    tabIndex?: number
    children: React.ReactNode
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={ariaLabel}
            tabIndex={tabIndex}
            className={cn(
                'group/film relative block shrink-0 overflow-hidden rounded-[10px] shadow-[0_12px_34px_rgba(19,18,16,0.18)]',
                className
            )}
        >
            {children}
            {/* frosted-white pill with a black play triangle + black label, bottom-left */}
            <span className="pointer-events-none absolute bottom-2 left-2 inline-flex items-center gap-1.5 rounded-[10px] bg-white/80 py-1.5 pl-2.5 pr-3 text-[#131210] backdrop-blur-md transition-transform duration-200 group-hover/film:scale-[1.04]">
                <Play className="size-2.5 fill-current" />
                <span className="text-[11px] font-semibold uppercase leading-none tracking-[0.05em]">{label}</span>
            </span>
        </button>
    )
}
